import { useCallback, useEffect, useRef, useState } from "react";

/** รายการแบบ cursor (nextCursor): fetch(cursor) -> { items, nextCursor } ; deps เปลี่ยน = เริ่มใหม่ */
export default function useCursorList(fetch, deps = []) {
  const [s, setS] = useState({ items: [], next: null, loading: true, more: false, error: "" });
  const fnRef = useRef(fetch);
  fnRef.current = fetch;
  const ref = useRef(s);
  ref.current = s;
  const tok = useRef(0);
  const run = useCallback((cursor, reset) => {
    const t = ++tok.current;
    setS((p) => ({ ...p, loading: reset, more: !reset, error: "" }));
    Promise.resolve()
      .then(() => fnRef.current(cursor))
      .then((r) => t === tok.current && setS((p) => ({ items: reset ? r.items || [] : [...p.items, ...(r.items || [])], next: r.nextCursor || null, loading: false, more: false, error: "" })))
      .catch((e) => t === tok.current && setS((p) => ({ ...p, loading: false, more: false, error: e?.message || "โหลดข้อมูลไม่สำเร็จ" })));
  }, []);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { run(undefined, true); }, deps);
  const loadMore = useCallback(() => { if (ref.current.next && !ref.current.more) run(ref.current.next, false); }, [run]);
  const reload = useCallback(() => run(undefined, true), [run]);
  const patch = useCallback((id, fn) => setS((p) => ({ ...p, items: p.items.map((x) => (x.id === id ? fn(x) : x)) })), []);
  return { ...s, loadMore, reload, patch };
}
